import React, { useEffect, useState } from "react";
import { getAllEmployees } from "../../../../api/hrDashboard";

const Notifications = () => {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllEmployees()
      .then((res) => {
        const employees = res.data || [];
        const today = new Date();
        const thirtyDaysAgo = new Date(); thirtyDaysAgo.setDate(today.getDate() - 30);
        const list = [];

        employees.forEach((e) => {
          const name = `${e.firstName||""} ${e.lastName||""}`.trim() || "Employee";
          if (e.dob) {
            const dob = new Date(e.dob);
            if (dob.getDate() === today.getDate() && dob.getMonth() === today.getMonth()) {
              list.push({ type: "birthday", title: `"${name}" turns ${today.getFullYear()-dob.getFullYear()} today`, sub: "BIRTHDAY", note: "Today" });
            }
          }
          if (e.dateOfJoining) {
            const j = new Date(e.dateOfJoining);
            if (j.getDate() === today.getDate() && j.getMonth() === today.getMonth() && j.getFullYear() !== today.getFullYear()) {
              list.push({ type: "anniversary", title: `"${name}" – ${today.getFullYear()-j.getFullYear()} year work anniversary`, sub: "WORK ANNIVERSARY", note: "Today" });
            }
          }
          if (e.deboardEmp) {
            list.push({ type: "expiring", title: `${name} separation processed`, sub: "EXPIRING", note: "Urgent", urgent: true });
          }
        });

        const newHires = employees.filter(e => !e.deboardEmp && e.dateOfJoining && new Date(e.dateOfJoining) >= thirtyDaysAgo);
        if (newHires.length > 0) {
          list.push({ type: "renewal", title: `${newHires.length} new hire${newHires.length > 1 ? "s" : ""} joined this month`, sub: "RENEWAL", note: "This week" });
        }

        if (list.length === 0) {
          list.push({ type: "ok", title: "All caught up! No new notifications.", sub: "STATUS", note: "Today" });
        }
        setNotes(list.slice(0, 5));
      })
      .catch(() => setNotes([{ type: "expiring", title: "Could not load notifications", sub: "ERROR", note: "", urgent: true }]))
      .finally(() => setLoading(false));
  }, []);

  const iconStyle = {
    birthday:    { bg: "#eff6ff", symbol: "🎂" },
    anniversary: { bg: "#f0fdf4", symbol: "🎉" },
    expiring:    { bg: "#fff7ed", symbol: "📋" },
    renewal:     { bg: "#fefce8", symbol: "📄" },
    ok:          { bg: "#f0fdf4", symbol: "✅" },
  };

  const subColor = {
    birthday: "#4f6ef7", anniversary: "#22c55e", expiring: "#ef4444", renewal: "#d97706", ok: "#22c55e",
  };

  return (
    <>
      <style>{`
        .nf-card {
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 10px;
          padding: 16px;
          height: 100%;
          box-sizing: border-box;
        }
        .nf-title { font-weight: 600; font-size: 13px; color: #1e293b; margin-bottom: 14px; }
        .nf-item {
          display: flex;
          gap: 12px;
          align-items: flex-start;
          padding: 10px 0;
          border-bottom: 1px solid #f3f4f6;
        }
        .nf-item:last-child { border-bottom: none; padding-bottom: 0; }
        .nf-icon {
          width: 32px; height: 32px; border-radius: 8px;
          display: flex; align-items: center; justify-content: center;
          font-size: 14px; flex-shrink: 0;
        }
        .nf-item-title { font-size: 12px; font-weight: 500; color: #1e293b; margin-bottom: 3px; }
        .nf-item-sub {
          font-size: 10px; font-weight: 700;
          letter-spacing: 0.04em;
          display: flex; align-items: center; gap: 5px;
        }
        .nf-item-note { font-weight: 400; color: #9ca3af; }
      `}</style>
      <div className="nf-card">
        <div className="nf-title">Notifications</div>
        {loading ? (
          <div style={{ color: "#9ca3af", fontSize: 12 }}>Loading...</div>
        ) : notes.map((n, i) => {
          const ic = iconStyle[n.type] || iconStyle.ok;
          const sc = subColor[n.type] || "#6b7280";
          return (
            <div key={i} className="nf-item">
              <div className="nf-icon" style={{ background: ic.bg }}>{ic.symbol}</div>
              <div>
                <div className="nf-item-title">{n.title}</div>
                <div className="nf-item-sub" style={{ color: n.urgent ? "#ef4444" : sc }}>
                  {n.sub}
                  {n.note && <span className="nf-item-note">· {n.note}</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Notifications;